<template>
  <div>
    <div class="col float-right">
      <q-btn-group outline>
        <!-- [S]결재관련 버튼 -->
        <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
        <!-- param.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
        <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
        <!-- param.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
        <c-appr-btn
          ref="appr-btn"
          name="appr-btn"
          :editable="editable"
          :approvalInfo="approvalInfo"
          @beforeApprAction="saveDataAppr"
          @callbackApprAction="approvalCallback"
          @requestAfterAction="getDetail"
        />
        <c-qr-btn
          :mobileUrl="
            '/sop/edu/result/educationResult?eduEducationId=' +
            param.eduEducationId
          "
        >
          <!-- -교육명 : ' -->
          <!-- -교육일시 : ' -->
          <!-- <template slot="detail">
            <b>{{$label('LBL0002873')}}</b>{{educationInfo.educationName}}
            <br>
            <b>{{$label('LBL0002874')}} </b>{{educationInfo.educationDate}}
          </template> -->
        </c-qr-btn>
        <!-- 완료 -->
        <!-- <c-btn v-show="editable&&!disabled" :showLoading="false" label="LBLCOMPLETE" icon="check"  @btnClicked="resultComplete" /> -->
        <!-- 교육결과서 -->
        <c-btn
          v-show="editable && isComplete"
          label="LBL0002901"
          icon="print"
          @btnClicked="btnResultReport"
        />
        <!-- 대상자 연명부 -->
        <c-btn
          v-show="editable && isComplete"
          label="LBL0002902"
          icon="print"
          @btnClicked="btnResultUsers"
        />
      </q-btn-group>
    </div>
    <c-tab
      type="vertical"
      :height.sync="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param="param"
          :planUpdateBtnData="param.planUpdateBtnData"
          :educationInfo.sync="educationInfo"
          @setData="setData"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "education-result-tab",
  props: {
    param: {
      type: Object,
      default: () => ({
        eduEducationId: "",
        searchResult: {
          flag: "",
          isSearch: false,
        },
        planUpdateBtnData: {
          title: "LBLPLAN",
          flag: false,
          research: "",
          planResearch: "",
        },
      }),
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      educationInfo: {
        eduEducationId: "",
        educationName: "",
        eduCourseId: "",
        plantCd: "",
        educationCourseName: "",
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: "",
        departmentDeptName: "",
        executionBudget: "",
        estimatedEducationExpenses: "",
        educationMethodName: "",
        educationMethodCd: null,
        educationOverview: "",
        evaluationEvalCd: null,
        documentStatusCd: "",
        qrCodeRoute: "",

        regUserId: "",
        chgUserId: "",
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
        eduEvalUserList: [],
        deleteEduEvalUserList: [],

        eduQuestionFlag: "N",
        eduQuestionMstId: "",
        eduQuestionPassScore: 0,
      },
      completeUrl: "",
      editable: true,
      splitter: 5,
      tab: "educationResultInfo",
      printResultUrl: "",
      printResultUserUrl: "",
      getUrl: "",
      updateUrl: "",
      isApproval: false,
    };
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.educationInfo.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.educationInfo.approvalStatusCd,
        apprEditable:
          this.educationInfo.approvalStatusCd === null ||
          this.educationInfo.approvalStatusCd == "ASC0000001", // 결재버튼 활성화 기준
        param: this.educationInfo, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: "APTC000026", // 결재유형코드
        approvalParamValue: {
          // 결재상세화면 파라미터
          eduEducationId: this.param.eduEducationId,
          isFullScreen: false,
        },
        approvalRequestName:
          "교육결과 [" + this.educationInfo.educationName + "]", // 결재요청명 (문서 title)
        approvalConnId: this.param.eduEducationId, // 결재연결용 업무일련번호 (문서 key)
      };
    },
    tabHeight() {
      let numHeight = this.height
        ? Number(this.$_.replace(this.height, "px", ""))
        : 600;
      numHeight = numHeight - 40;
      return numHeight + "px";
    },
    disabled() {
      return (
        this.educationInfo.documentStatusCd === "ESC000010" ||
        (Boolean(this.educationInfo.sysApprovalRequestId) &&
          this.educationInfo.approvalStatusCd !== "ASC0000002")
      );
    },
    isComplete() {
      return this.educationInfo.documentStatusCd === "ESC000010";
    },
    tabItems() {
      return [
        // 기본정보
        {
          name: "educationResultInfo",
          icon: "edit",
          label: "LBLBASEINFO",
          component: () => import(`${"./educationResultInfo.vue"}`),
        },
        // 교육이수
        {
          name: "educationComplete",
          icon: "how_to_reg",
          label: "LBL0002903",
          component: () => import(`${"./educationComplete.vue"}`),
        },
      ];
    },
  },
  watch: {
    "param.planUpdateBtnData.research"() {
      this.getDetail();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;

      this.getUrl = selectConfig.sop.edu.result.get.url;
      this.updateUrl = transactionConfig.sop.edu.result.update.url;
      this.completeUrl = transactionConfig.sop.edu.result.complete.url;
      this.printResultUrl = selectConfig.sop.edu.result.print.result.url;
      this.printResultUserUrl =
        selectConfig.sop.edu.result.print.targetUser.url;
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.param.eduEducationId) {
        this.$http.url = this.$format(this.getUrl, this.param.eduEducationId);
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.educationInfo = _result.data;
        });
      }
    },
    setData(data) {
      this.param.eduEducationId = data;
      this.getDetail();
    },
    resultComplete() {
      let flag = false;
      if (!flag) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSG0000868", // 결과완료하시겠습니까?(저장과 함께 처리됩니다.)
          // TODO : 점검완료 하시겠습니까?
          type: "warning", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.educationInfo.documentStatusCd = "ESC000010";
            this.educationInfo.regUserId = this.$store.getters.user.userId;
            this.educationInfo.chgUserId = this.$store.getters.user.userId;
            this.$http.url = this.completeUrl;
            this.$http.type = "PUT";
            this.$http.param = this.educationInfo;
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    btnResultReport() {
      let thisVue = this;
      this.$http.url = this.printResultUrl;
      this.$http.type = "GET";
      this.$http.param = {
        eduEducationId: this.param.eduEducationId,
      };
      this.$http.request(
        (_result) => {
          let fileOrgNm = this.educationInfo.educationName + " 결과서.xlsx";
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {},
      );
    },
    btnResultUsers() {
      let thisVue = this;
      this.$http.url = this.printResultUserUrl;
      this.$http.type = "GET";
      this.$http.param = {
        eduEducationId: this.param.eduEducationId,
      };
      this.$http.request(
        (_result) => {
          let fileOrgNm = this.educationInfo.educationName + " 연명부.docx";
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {},
      );
    },
    saveDataAppr() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message: "결재요청 하기 전 입력된 값을 저장합니다.\n진행하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.educationInfo.regUserId = this.$store.getters.user.userId;
          this.educationInfo.chgUserId = this.$store.getters.user.userId;
          let promises = [
            {
              func: this.approvalValue,
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    // [S] 결재관련
    approvalCallback() {
      // 결재관련 결재요청버튼 callback
      this.$refs["appr-btn"].apprRequestPop();
    },
    approvalValue() {
      return new Promise((resolve) => {
        this.isApproval = !this.isApproval;
        resolve(true);
      });
    },
  },
};
</script>
